import { useMutation, gql } from "@apollo/client"
import { USER_TRAINING_FIELDS } from "."

const COMPLETE_USER_TRAINING_MODULE_KNOWLEDGE_MUTATION = gql`
  mutation CompleteUserTrainingModuleKnowledge(
    $userTraining: ID!
    $module: ID!
    $moduleKnowledge: ID!
  ) {
    completeUserTrainingModuleKnowledge(
      userTraining: $userTraining
      module: $module
      moduleKnowledge: $moduleKnowledge
    ) {
      ${USER_TRAINING_FIELDS}
    }
  }
`

const useMutationCompleteUserTrainingModuleKnowledge = () =>
  useMutation(COMPLETE_USER_TRAINING_MODULE_KNOWLEDGE_MUTATION)

export { useMutationCompleteUserTrainingModuleKnowledge }
